module.exports = {
  content: {
    tips: "提示",
    logout: "确定退出登录吗？",
    cancel: "取消",
    confirm: "确定",
    whetherOrder: "是否取消该订单？",
    restored: "您确定要取消该订单吗？取消订单后，不能恢复。",
    deleteOrder: "是否删除该订单？",
    deleteDestored: "您确定要删除该订单吗？删除订单后，不能恢复。",
    confirmReceipt: "是否确认收货？",
    correctly: "为了保证您的售后权益，请收到商品检查无误后再确认收货。",
    pleaseProducts: "请选择售后商品",
    selectAll: "全选",
    batchManagement: "批量管理",
    deleteBtn: "删除",
    saveBtn: "保存",
    check: "查看",
    packUp: "收起",
    answerContinue: "此操作将删除选中的回答, 是否继续?",
    batchDelete: "批量删除",
    operationRecord: "此操作将删除选中的记录, 是否继续?"
  }
}


// WEBPACK FOOTER //
// ./src/assets/lang/zh-cn/common.js